<template>
  <span :class="['char-count', { 'char-count--inline': inline }]">{{ count }}字</span>
</template>

<script>
import { sumLengths } from './charCountUtil'

export default {
  name: 'CharCount',
  props: {
    // 单值计数（普通 textarea 品名/唛头）
    value: { type: [String, Number], default: '' },
    // 多值求和（可选）
    values: { type: Array, default: null },
    // 收发通多行汇总：读取 form[prefix+'Line1' … prefix+'Line'+lineCount] 求和
    form: { type: Object, default: null },
    prefix: { type: String, default: '' },
    lineCount: { type: Number, default: 7 },
    // 行内展示（用于收发通等无独立定位容器的场景：放在 flex 行末尾右对齐）
    inline: { type: Boolean, default: false }
  },
  computed: {
    count() {
      if (Array.isArray(this.values)) return sumLengths(this.values)
      if (this.form && this.prefix) {
        const arr = []
        for (let i = 1; i <= this.lineCount; i++) {
          arr.push(this.form[this.prefix + 'Line' + i])
        }
        return sumLengths(arr)
      }
      const v = this.value
      return (v == null ? '' : String(v)).length
    }
  }
}
</script>

<style scoped>
.char-count {
  position: absolute;
  right: 11px;
  bottom: 2px;
  font-size: 10px;
  color: #909399;
  line-height: 1;
  pointer-events: none;
  z-index: 5;
}
.char-count--inline {
  position: static;
  margin-left: auto;
  padding-left: 8px;
  pointer-events: auto;
}
</style>
